import { HarborClient, type IApiClient } from "@pharaday/api";
import { type AxiosInstance } from "axios";
import { injectable } from "inversify";

import { AuthenticatedContainer } from "../../../core/authenticated.container";
import { UserRepository } from "../../application/store/user.repository";
import type { UserProfileDto } from "../dto/user-profile.dto";

@injectable()
export class RestUserRepository extends UserRepository {
  public readonly axios: AxiosInstance;

  constructor() {
    super();
    this.axios = AuthenticatedContainer.get<IApiClient>(HarborClient).getInstance();
  }

  async getUserProfile() {
    const { data } = await this.axios.get<UserProfileDto>("/profile");
    return data;
  }
}
